export function OrSeparator() {
  return (
    <div className='flex items-center gap-3 my-2'>
      <div className='flex-1 h-px bg-iq-grey-light' />
      <span className='text-xs text-iq-grey-medium'>or</span>
      <div className='flex-1 h-px bg-iq-grey-light' />
    </div>
  );
}
